import {ajax} from '../../utils/ajax';

export function getUserList(){
    return ajax('tokenJson', '/users/', 'GET', false)
}

export function ActiveDeactiveUsers(uid, status){
    console.log(uid)
    console.log(status)
    return ajax('tokenJson', '/users/Activation', 'post', true, {id: uid,status: status})
}
